import { makeStyles } from 'tss-react/mui';

const useStylesLogo = makeStyles()((theme)=>({
    logoBackground: {
        backgroundColor: theme.secondaryColor,
    }
}));

export default useStylesLogo;